<template>
  <div :class="classContents" style="padding: 5px 5px 5px 5px;">
    <div class="upper-area">
      <v-row>
        <v-col cols="4"></v-col>
        <v-col cols="8">
          <v-row>
            <v-col cols="12">
              <h1 class="hx">OWLens {{ version }}</h1>
            </v-col>
          </v-row>
          <v-row class="row-pad">
            <v-col cols="1"></v-col>
            <v-col cols="11">
              <p>{{ license.type }}</p>
            </v-col>
          </v-row>
          <v-row class="row-pad">
            <v-col cols="1"></v-col>
            <v-col cols="3">
              <p>{{ $t('admin.licensed.features') }}:</p>
            </v-col>
            <v-col cols="8">
              <p>{{ licenseFeatures }}</p>
            </v-col>
          </v-row>
          <v-row class="row-pad">
            <v-col cols="1"></v-col>
            <v-col cols="11">
              <p>{{ $t('admin.rights.statement', { year: new Date().getFullYear() }) }}</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { isEmpty } from 'lodash';
import { api } from '../../api/common/instances';
export default {
  data() {
    return {
      version: '4.3.2',
      license: {},
    };
  },
  computed: {
    licenseFeatures() {
      if (isEmpty(this.license)) return '';
      return this.license.features.reduce((acc, elm, idx) => {
        if (idx == 0) return elm;
        return `${acc}, ${elm}`;
      }, '');
    },
    classContents() {
      return {
        'contents-background-dark': this.$vuetify.theme.isDark,
      };
    },
  },
  methods: {
    async getOWLensVersion() {
      const { data } = await api.get('/admin/owlens-version');
      this.version = data;
    },
    async getLicense() {
      const { data } = await api.get('/admin/license');
      this.license = data;
    },
  },
  async created() {
    this.getOWLensVersion();
    this.getLicense();
  },
};
</script>

<style lang="scss" scoped>
.theme--dark .upper-area {
  padding: 0 12px 12px 12px;
  height: 400px;
  background: url(../../assets/image/loginBgDark.gif) no-repeat center 75%;
  background-size: contain;
  background-color: #161616;
}
.theme--light .upper-area {
  padding: 0 12px 12px 12px;
  height: 400px;
  background: url(../../assets/image/loginBgLight.gif) no-repeat center 75%;
  background-size: contain;
}
.row-pad {
  padding-top: 10px;
}
.hx {
  display: block;
  font-size: 3em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: bold;
}
.close-btn {
  float: right;
  margin-top: 10px;
}
</style>
